module.exports = __webpack_public_path__ + "media/images/salem_village_1692-51f4c0d29514eb8fdd22ff1afe554c84.jpg";